import { useMutation } from 'react-query';

import { exportSchedulingResultsAsVersion as mutationFn } from 'api/endPoints/exportSchedulingResultsAsVersion';

export const useMutationExportNewVersion = () => {
    return useMutation<unknown, QueryError, QueryParams>({
        mutationFn: (params) => mutationFn(params),
    });
};

interface QueryParams {
    metaDataId: number;
    contractId: number;
    projectId: number;
    versionName: string;
    versionDate: number;
    key: string;
}
